import immutable from 'immutable';

const SAVE = '@@Profile/SAVE';
const SAVE_SUCCESS = '@@Profile/SAVE_SUCCESS';
const SAVE_FAIL = '@@Profile/SAVE_FAIL';

const initialState = immutable.Map();

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case SAVE:
			return state
				.set('saving', true);

		case SAVE_SUCCESS:
		case SAVE_FAIL:
			return state
				.set('saving', false);

		default:
			return state;
	}
}

export function save(data) {
	return {
		types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
		promise: (client) => client.call('user.saveProfile', {data}, {progress:true})
	};
}




// WEBPACK FOOTER //
// ./src/redux/modules/profile.js